import { getLabel } from "../../common/getLabel";
import Pagination from "../../common/reactPaginate";
import TableSkeleton from "../../common/TableSkeleton";

const Listing = (props) => {
    const { contentPages, totalCount, loading, error, currentPage, limit, handlePaginate, handleFormShow, deleteModalOpen, editContentPages } = props;

    const handlePageClick = (selectedPage) => {
        handlePaginate(selectedPage);
    };
    const calculateSerialNumber = (index) => (currentPage - 1) * limit + index + 1;
    const totalPages = Math.ceil(totalCount / limit);

    return (
        <>
            <form id="contentPage-listing">
                <table className="table table-striped table-bordered" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th className="table-id">{getLabel("LBL_Sr._No.")}</th>
                            <th>{getLabel("LBL_Page_Title")}</th>
                            <th className="table-action">{getLabel("LBL_Action")}</th>
                        </tr>
                    </thead>
                    <tbody>

                        {loading ? (
                            <>
                                <TableSkeleton cards={limit} count={3} />
                            </>
                        ) : error ? (
                            <tr className="no--record">
                                <td colspan="3" className="text-center">{getLabel("LBL_Some_thing_wrong_Please_try_again_later")}</td>
                            </tr>
                        ) : (
                            <>
                                {contentPages && contentPages.length > 0 ? (
                                    contentPages.map((elem, index) => (
                                        <tr className="actions" key={index}>
                                            <td>{calculateSerialNumber(index)} </td>
                                            <td>
                                                <div className="verified-wrap">
                                                    <span className="user-profile_title">{elem.cpage_title}</span>
                                                </div>
                                            </td>

                                            <td>
                                                <span className="action">
                                                    <ul>
                                                        <li>
                                                            <a onClick={() => handleFormShow(elem.cpage_id)} >
                                                                <i className='bx bx-pencil' variant="primary"></i>
                                                            </a>
                                                        </li>
                                                        {editContentPages && (
                                                            <li>
                                                                <a onClick={() => deleteModalOpen(elem.cpage_id)} >
                                                                    <i className='bx bx-trash'></i>
                                                                </a>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="no--record">
                                        <td colspan="3" className="text-center">{getLabel("LBL_No_result_found")}</td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </form>
            {contentPages && contentPages.length > 0 && (
                <Pagination
                    totalPages={totalPages}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage} />
            )}

        </>
    )
}
export default Listing